import { render } from "./merchant_coupons.vue?vue&type=template&id=dc7b4086&scoped=true&ts=true"
import script from "./merchant_coupons.vue?vue&type=script&lang=ts"
export * from "./merchant_coupons.vue?vue&type=script&lang=ts"

import "./merchant_coupons.vue?vue&type=style&index=0&id=dc7b4086&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc7b4086"]])

export default __exports__